module.exports = __webpack_public_path__ + "static/media/slika1.b84b9cd3.png";